import React from 'react';
import { createContext } from '@shared/utils/createContext';
import { useEventWebsiteDesign } from '@shared/hooks/useEventWebsiteDesign/useEventWebsiteDesign';

/**
 * The theme of the event's website. Tiles of this theme show the "Matches Your Site" badge,
 * and the gallery promotes it to the front.
 *
 * `strict: false` because the public shop and the PDP have no provider: there it is `undefined`.
 */
const [Provider, useWebsiteThemeIdContext] = createContext<string | undefined>({
  name: 'WebsiteThemeIdContext',
  strict: false,
});

/** Resolves the website's theme once, so tiles read it here instead of each subscribing to the design. */
export const WebsiteThemeIdProvider = ({ eventHandle, children }: Readonly<{ eventHandle?: string; children: React.ReactNode }>) => {
  // The shop's own handle, not the ambient event: without one (public shop) nothing matches.
  const { themeId } = useEventWebsiteDesign(eventHandle ?? '');
  return <Provider value={themeId ?? undefined}>{children}</Provider>;
};

export const useWebsiteThemeId = (): string | undefined => useWebsiteThemeIdContext();
